import _ from 'lodash';
import React from 'react';

let timer = null;

const WebdevLoader = ({ onLoaded }) => {
    const [loaded, setLoaded] = React.useState(false);
    const [tries, setTries] = React.useState(0);

    React.useEffect(() => {
        if (!loaded) {
            if (_.isNil(window.affichageDefaut)) {
                timer = setTimeout(() => {
                    setTries(t => t + 1);
                }, 300);
            } else {
                clearTimeout(timer)
                setLoaded(true);
            }
        }
    }, [loaded, tries]);

    React.useEffect(() => {
        if (loaded) onLoaded();
    },[loaded])

    return null;
};

export default WebdevLoader;